<section class="identity-section" *ngIf="topSportSequence && topSportSequence.length > 0">
  <div class="container-fluid">
    <div class="row align-items-center p-lg-0 px-4 px-md-5">
      <!-- Left Content Column -->
      <div class="col-12 col-lg-4 col-md-12">
        <h2 class="identity-heading hf f80">WHO WE ARE</h2>

        <div class="identity-description">
          <p class="f24 pb-3">Our mission is to inspire people to dream bigger, live harder, and engage with life at its highest intensity.</p>
          <p class="f18 pb-3">
            XDGE represents extreme sports at their core: disciplines that demand full commitment. We are for those who feel fear, acknowledge it, and
            move forward anyway. For those who choose purpose over comfort and fervor over indifference.
          </p>
          <p class="f18 pb-3">
            If it does not challenge your limits, it does not qualify. This is a collective for individuals who refuse to be spectators in their own
            lives, and choose the road less traveled, every time.
          </p>
          <p class="f18 pb-3">If you are not already sending it, XDGE exists to be the spark.</p>
        </div>

        <div class="identity-actions py-4">
          <button class="hero-btn primary text-uppercase f16" (click)="onEvaluateClick()">EVALUATE MY LEVEL</button>
          <button class="hero-btn ghost text-uppercase f16" (click)="onExploreClick($event)">EXPLORE SPORTS</button>
        </div>
      </div>

      <!-- Right Elements Grid Column -->
      <div class="col-12 col-lg-8 col-md-12">
        <div class="elements-grid">
          <!-- AIR -->
          <div class="element-card" *ngIf="getAirElement() as item">
            <div class="image-wrapper">
              <img
                [ngSrc]="
                  item.image
                    ? fileDirectoriesPath + item.image
                    : item.largeImage
                      ? fileDirectoriesPath + item.largeImage
                      : 'assets/images/ic_level.svg'
                "
                onerror="this.ngSrc = 'assets/images/ic_level.svg'"
                alt="Air Element"
                fill
                [ngClass]="item.image || item.largeImage ? 'banner-img-cover' : ''"
                [routerLink]="userLoggedIn ? '/sports/' + item.id : '/'"
                (click)="userLoggedIn ? '' : onExploreClick($event)"
              />
              <div class="card-overlay"></div>
              <span class="element-label f40 hf">AIR</span>
            </div>
          </div>

          <!-- EARTH -->
          <div class="element-card" *ngIf="getEarthElement() as item">
            <div class="image-wrapper">
              <img
                [ngSrc]="
                  item.image
                    ? fileDirectoriesPath + item.image
                    : item.largeImage
                      ? fileDirectoriesPath + item.largeImage
                      : 'assets/images/ic_level.svg'
                "
                onerror="this.ngSrc = 'assets/images/ic_level.svg'"
                alt="Earth Element"
                fill
                [ngClass]="item.image || item.largeImage ? 'banner-img-cover' : ''"
                [routerLink]="userLoggedIn ? '/sports/' + item.id : '/'"
                (click)="userLoggedIn ? '' : onExploreClick($event)"
              />
              <div class="card-overlay"></div>
              <span class="element-label f40 hf">EARTH</span>
            </div>
          </div>

          <!-- SNOW/ICE -->
          <div class="element-card" *ngIf="getSnowElement() as item">
            <div class="image-wrapper">
              <img
                [ngSrc]="
                  item.image
                    ? fileDirectoriesPath + item.image
                    : item.largeImage
                      ? fileDirectoriesPath + item.largeImage
                      : 'assets/images/ic_level.svg'
                "
                onerror="this.ngSrc = 'assets/images/ic_level.svg'"
                alt="Snow/Ice Element"
                fill
                [ngClass]="item.image || item.largeImage ? 'banner-img-cover' : ''"
                [routerLink]="userLoggedIn ? '/sports/' + item.id : '/'"
                (click)="userLoggedIn ? '' : onExploreClick($event)"
              />
              <div class="card-overlay"></div>
              <span class="element-label f40 hf">ICE</span>
            </div>
          </div>

          <!-- WATER -->
          <div class="element-card" *ngIf="getWaterElement() as item">
            <div class="image-wrapper">
              <img
                [ngSrc]="
                  item.image
                    ? fileDirectoriesPath + item.image
                    : item.largeImage
                      ? fileDirectoriesPath + item.largeImage
                      : 'assets/images/ic_level.svg'
                "
                onerror="this.ngSrc = 'assets/images/ic_level.svg'"
                alt="Water Element"
                fill
                [ngClass]="item.image || item.largeImage ? 'banner-img-cover' : ''"
                [routerLink]="userLoggedIn ? '/sports/' + item.id : '/'"
                (click)="userLoggedIn ? '' : onExploreClick($event)"
              />
              <div class="card-overlay"></div>
              <span class="element-label f40 hf">WATER</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
